import React from 'react'
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
        <p>All rights reserved</p>
        <ul>
            <li>
                Terms of Services
            </li>
            <li>
                Terms of Services
            </li>
        </ul>
      
    </div>
  )
}

export default Footer
